import { useParams } from "react-router";

import { useFetchQuotesQuery } from "../services/api/quotesApi/quotes";

export function useContactQuotes() {
  const { organisationId, contactId } = useParams<{ organisationId?: string; contactId?: string }>();

  const api = useFetchQuotesQuery({
    organisationId,
    contactId: Number(contactId),
  }, {
    skip: !organisationId || !contactId || Number.isNaN(Number(contactId)),
  });

  // Ensure object is always present
  return {
    ...api,
    quotes: api.data?.quotes ?? {},
  };
}
